import React, { useEffect, useMemo } from "react";
import { createTouch } from "../store/actions/projectAction";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "../component/Partial/SelectField";
import TextField from "../component/Partial/TextField";
import Button from "../component/Partial/Button";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

function AddTouches() {
  const sections = useSelector((state) => state.project?.sections);
  const rooms = useSelector((state) => state.project?.rooms);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const params = useParams();
  const dispatch = useDispatch();

  const handleCreateTouchButtonClicked = ({ sectionId, roomId, name }) => {
    dispatch(
      createTouch({
        name: name,
        projectId: params?.id,
        sectionId: sectionId,
        roomId: roomId,
      })
    ).then(() => {
      setValue("name", "");
    });
  };

  const sectionsOptions = useMemo(() => {
    return sections?.map((item) => {
      return {
        label: item?.name,
        value: item?._id,
      };
    });
  }, [sections]);


  const selecteedSection = watch("sectionId");

  console.log(selecteedSection);
  


  const roomsOptions = useMemo(() => {
    return rooms?.filter((item) => item?.section?._id == selecteedSection)?.map((item) => {
      return {
        label: item?.name,
        value: item?._id,
      };
    });
  }, [rooms,selecteedSection]);

  useEffect(() => {
    if (sectionsOptions?.length) {
      setValue("sectionId", sections[0]?._id);
    }

    if (roomsOptions?.length) {
      setValue("roomId", rooms[0]?._id);
    }
  }, [rooms, sections]);

  return (
    <div>
      <div className="text-2xl mb-2">
        <p>Add Touch Switch in your room</p>
      </div>
      <form
        className="flex gap-5"
        onSubmit={handleSubmit(handleCreateTouchButtonClicked)}
      >
        <SelectField
          options={sectionsOptions}
          placeholder="Select Section"
          register={register("sectionId", {
            required: "Section is required!",
          })}
        />

        <SelectField
          options={roomsOptions}
          placeholder="Select Room"
          register={register("roomId", {
            required: "Section is required!",
          })}
        />

        <TextField
          placeholder="Name Touch Panel"
          register={register("name", {
            required: "Section is required!",
          })}
        />
        <Button text="Add" type="submit" className="px-14" />
      </form>
    </div>
  );
}

export default AddTouches;
